import { DesktopAppDialog } from "./desktop-app-dialog.js";
import { DesktopAppFloatingButton } from "./desktop-app-floating-button.js";

interface DesktopAppProps {
  open: boolean;
  onDismiss: () => void;
  onRequestOpen: () => void;
  onViewMore: () => void;
  showFloatingButton: boolean;
  floatingButtonStackIndex?: number;
}

export const DesktopApp = ({
  open,
  onDismiss,
  onRequestOpen,
  onViewMore,
  showFloatingButton,
  floatingButtonStackIndex = 0,
}: DesktopAppProps) => (
  <>
    <DesktopAppDialog
      onDismiss={onDismiss}
      onViewMore={onViewMore}
      open={open}
    />
    {Boolean(showFloatingButton) && (
      <DesktopAppFloatingButton
        onClick={onRequestOpen}
        stackIndex={floatingButtonStackIndex}
      />
    )}
  </>
);
